import { Button, Form, Modal } from '@mairistem/composants';
import { request } from '@mairistem/tools';
import dayjs from 'dayjs';
import React from 'react';
import { toast } from 'react-toastify';

import { putArrete } from '@/routes';
import type { ArreteType } from '@/types';

type TransfertComptableModalProps = {
  arrete: ArreteType;
  onClose: () => void;
  onArreteUpdate: (updated: ArreteType) => void;
};

type ValidationField = 'dateValidationOrdonnateur' | 'dateValidationPosteComptable';

const TransfertComptableModal = (props: TransfertComptableModalProps) => {
  const { arrete, onClose, onArreteUpdate } = props;
  const [loading, setLoading] = React.useState(false);

  const toggleValidation = React.useCallback(
    (field: ValidationField) => () => {
      const next: ArreteType = {
        ...arrete,
        [field]: arrete[field] ? null : dayjs().format('YYYY-MM-DD HH:mm:ss'),
      };
      setLoading(true);
      request
        .put(putArrete(arrete.identifiant), next)
        .then((updated: any) => onArreteUpdate(updated as ArreteType))
        .catch(() => toast.error('Erreur lors de la mise à jour de la validation'))
        .finally(() => setLoading(false));
    },
    [arrete, onArreteUpdate],
  );

  return (
    <Modal
      open
      size="tiny"
      onClose={!loading ? onClose : undefined}
      {...(!loading && { closeIcon: true })}
    >
      <Modal.Header>{`Validation du titrage de l'${(arrete.libelle || '').toLowerCase()}`}</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Checkbox
            label="Validation ordonnateur"
            checked={!!arrete.dateValidationOrdonnateur}
            onChange={toggleValidation('dateValidationOrdonnateur')}
            disabled={loading}
          />
          <Form.Checkbox
            label="Validation poste comptable"
            checked={!!arrete.dateValidationPosteComptable}
            onChange={toggleValidation('dateValidationPosteComptable')}
            disabled={loading}
          />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button
          basic
          size="tiny"
          icon="close"
          content="Fermer"
          onClick={onClose}
          disabled={loading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default TransfertComptableModal;
